import React from "react";
import { Dropdown } from "react-bootstrap";
import PropTypes from "prop-types";

const AudioFormatDropdown = ({ value, onChange, disabled, options }) => {
  return (
    <Dropdown disabled={disabled}>
      <Dropdown.Toggle variant="dark" id="dropdown-audio-format">
        {options.find((option) => option.value === value)?.label || "Formato de Áudio"}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {options.map((option, index) => (
          <Dropdown.Item key={index} onClick={() => onChange(option.value)}>
            {option.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

AudioFormatDropdown.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
};

AudioFormatDropdown.defaultProps = {
  value: null,
  disabled: false,
};

export default AudioFormatDropdown;